/**
 * Utilita pro operace s náhodnými hodnotami.
 */
class Randomizer {
	/**
	 * Vytvoří náhodný řetězec.
	 * [Zdroj](https://stackoverflow.com/a/1349426/8315965)
	 * @param {number} length Požadovaná délka řetězce.
	 * @returns {string}
	 */
	createString (length) {
		let result = '';
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		const charactersLength = characters.length;
		for (let i = 0; i < length; i += 1) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	}
}

export default Randomizer;
